import React from 'react';
import {ShareButtons} from 'react-share';

const {
  FacebookShareButton,
  TwitterShareButton
} = ShareButtons;

function SocialShares(props) {
    const url = 'http://therohrabacherconspiracy.com';
    return (
    <div className="social-shares">
        <TwitterShareButton
            url={url}
            title='.@DanaRohrabacher is a proud member of the DC swamp, and he has the circle of questionable friends to prove it.'>
            <i className="fa fa-twitter social-circle" aria-hidden="true"></i>
          </TwitterShareButton>
          <FacebookShareButton url={url} title="The Rohrabacher Conspiracy"
          description="Congressman Dana Rohrabacher’s been in Washington a long time – and he’s picked up quite a circle of friends during his time in the swamp. From white supremacists, to imprisoned lobbyists, to Kremlin cronies, the Rohrabacher Conspiracy runs deep – check out our board to see just what the Congressman has been up to the last three decades he’s spent in DC.">
            <i className="fa fa-facebook social-circle"></i>
          </FacebookShareButton>
    </div>
    )
}

export default SocialShares;


// WEBPACK FOOTER //
// ./src/components/SocialShares.js